import type { Timestamp } from '@bufbuild/protobuf/wkt'
import type { ReactNode } from 'react'

export type ActivityEntry = {
  key: string
  timestamp?: Timestamp | Date
  node: ReactNode
  // Matches a DB comment entry to its live Liveblocks copy.
  dedupeKey?: string
}

export const commentDedupeKey = (time: Date): string => String(time.getTime())
